<template>
  <tbody class="table-body">
    <slot></slot>
  </tbody>
</template>

<script>
export default {
  name: "TableBody",
  props: {
    variant: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.table-body {
  width: 100%;
}
</style>
